import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

export default class App extends Vue {
    @Prop(String)
    appSection: string | null = null;

    @Prop(String)
    languageId: string | null = null;

    @Prop(Number)
    categoryId: number | null = null;

    @Prop(Number)
    familyId: number | null = null;

    @Prop(String)
    searchTerm: string | null = null;

    @Prop(String)
    gtagActionField: string | null = null;

    @Prop(Number)
    accountId: number = 0;

    @Prop(Number)
    accountUserId: number = 0;
}